module.exports = __webpack_public_path__ + "static/media/clock.8e846e15.svg";